import React, { useEffect, createElement } from 'react';
export function GoogleAnalytics() {
  useEffect(() => {
    // Initialize dataLayer and gtag BEFORE loading the script
    window.dataLayer = window.dataLayer || [];
    function gtag(..._args: unknown[]) {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    }
    ;
    (window as any).gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-C924K521GZ');
    // Load gtag.js script
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-C924K521GZ';
    script.async = true;
    document.head.appendChild(script);
  }, []);
  return null;
}